import { ID_BACK_IN_STOCK_CONTAINER } from '../constants';
import { bindBackInStockEvents } from '../events/event-handlers';
import { filterVariants } from '../product/variant-utils';
import { applyDynamicStyling } from '../ui/styling';

/**
 * @type{import('../index.d').renderBackInStockTemplate}
 */
export async function renderBackInStockTemplate(context, moduleContext, product) {
  const backInStockTemplate = moduleContext.settings.templateSettings().template;

  const backInStockContainer = document.querySelector(`#${ID_BACK_IN_STOCK_CONTAINER}`);

  const variants = product.variants;
  const filteredVariants = filterVariants(moduleContext, variants);

  if (backInStockContainer) {
    backInStockContainer.innerHTML = await context.templateRender(backInStockTemplate, {
      filteredVariants,
    });

    bindBackInStockEvents(context, product);
    applyDynamicStyling(context);
  }
}
